'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dInvoice$002dForm from "./app.data.-App-Document-Data-Invoice-Form.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dPurchase$002dOrder$0024$0024anon$00241 from "./app.data.-App-Document-Data-Purchase-Order$$anon$1.js";
import * as $j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo$002dForm$0024 from "./app.data.-App-Document-Organization-Info-Form$.js";
import * as $j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$002dForm$0024 from "./app.data.-Documentary-Credit-Data$package$-Documentary-Credit-Number-Form$.js";
import * as $j_app$002edata$002e$002dDocumentary$002dCredit$002dForm$002dData from "./app.data.-Documentary-Credit-Form-Data.js";
import * as $j_app$002edata$002e$002dInvoice$002dLine$002dItem$002dForm$0024 from "./app.data.-Invoice-Line-Item-Form$.js";
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$002dForm$0024 from "./app.data.-Purchase-Order-Contract-Data$package$-Purchase-Order-Number-Form$.js";
import * as $j_app$002edata$002e$002dPurchase$002dOrder$002dReference$002dForm from "./app.data.-Purchase-Order-Reference-Form.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dConsignee$0024 from "./app.data.data_point_types$package$-Consignee$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$002dForm$0024 from "./app.data.data_point_types$package$-Document-Number-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dHarmonized$002dSystem$002dCode$0024 from "./app.data.data_point_types$package$-Harmonized-System-Code$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dImporter$002dName$0024 from "./app.data.data_point_types$package$-Importer-Name$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$002dForm$0024 from "./app.data.data_point_types$package$-Issuing-Bank-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDelivery$0024 from "./app.data.data_point_types$package$-Place-Of-Delivery$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDischarge$0024 from "./app.data.data_point_types$package$-Place-Of-Discharge$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dLoading$0024 from "./app.data.data_point_types$package$-Place-Of-Loading$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dReceipt$0024 from "./app.data.data_point_types$package$-Place-Of-Receipt$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataPurchaseOrder(number, issuer, recipient, currency, lineItems, documentaryCredit, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, importer, consignee, harmonizedSystemCode) {
  this.Bu = null;
  this.Bt = null;
  this.Fk = null;
  this.Fb = null;
  this.Ff = null;
  this.Fc = null;
  this.Fj = null;
  this.Fi = null;
  this.Fg = null;
  this.Fh = null;
  this.Fe = null;
  this.Fa = null;
  this.Fd = null;
  this.Bu = number;
  this.Bt = issuer;
  this.Fk = recipient;
  this.Fb = currency;
  this.Ff = lineItems;
  this.Fc = documentaryCredit;
  this.Fj = placeOfReceipt;
  this.Fi = placeOfLoading;
  this.Fg = placeOfDelivery;
  this.Fh = placeOfDischarge;
  this.Fe = importer;
  this.Fa = consignee;
  this.Fd = harmonizedSystemCode;
}
export { $c_Lapp_data_AppDocumentDataPurchaseOrder as $c_Lapp_data_AppDocumentDataPurchaseOrder };
$p = $c_Lapp_data_AppDocumentDataPurchaseOrder.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataPurchaseOrder;
/** @constructor */
function $h_Lapp_data_AppDocumentDataPurchaseOrder() {
}
export { $h_Lapp_data_AppDocumentDataPurchaseOrder as $h_Lapp_data_AppDocumentDataPurchaseOrder };
$h_Lapp_data_AppDocumentDataPurchaseOrder.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataPurchaseOrder)) {
    if ((this.Bu === x$0.Bu)) {
      var x = this.Bt;
      var x$2 = x$0.Bt;
      var $x_11 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$3 = this.Fk;
      var x$4 = x$0.Fk;
      var $x_10 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$5 = this.Fb;
      var x$6 = x$0.Fb;
      var $x_9 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$7 = this.Ff;
      var x$8 = x$0.Ff;
      var $x_8 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$9 = this.Fc;
      var x$10 = x$0.Fc;
      var $x_7 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$11 = this.Fj;
      var x$12 = x$0.Fj;
      var $x_6 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$13 = this.Fi;
      var x$14 = x$0.Fi;
      var $x_5 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$15 = this.Fg;
      var x$16 = x$0.Fg;
      var $x_4 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$17 = this.Fh;
      var x$18 = x$0.Fh;
      var $x_3 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$19 = this.Fe;
      var x$20 = x$0.Fe;
      var $x_2 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$21 = this.Fa;
      var x$22 = x$0.Fa;
      var $x_1 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$23 = this.Fd;
      var x$24 = x$0.Fd;
      return ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 13;
});
$p.t = (function() {
  return "AppDocumentDataPurchaseOrder";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.Bu;
      break;
    }
    case 1: {
      return this.Bt;
      break;
    }
    case 2: {
      return this.Fk;
      break;
    }
    case 3: {
      return this.Fb;
      break;
    }
    case 4: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.Ff);
      break;
    }
    case 5: {
      return this.Fc;
      break;
    }
    case 6: {
      return this.Fj;
      break;
    }
    case 7: {
      return this.Fi;
      break;
    }
    case 8: {
      return this.Fg;
      break;
    }
    case 9: {
      return this.Fh;
      break;
    }
    case 10: {
      return this.Fe;
      break;
    }
    case 11: {
      return this.Fa;
      break;
    }
    case 12: {
      return this.Fd;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "issuer";
      break;
    }
    case 2: {
      return "recipient";
      break;
    }
    case 3: {
      return "currency";
      break;
    }
    case 4: {
      return "lineItems";
      break;
    }
    case 5: {
      return "documentaryCredit";
      break;
    }
    case 6: {
      return "placeOfReceipt";
      break;
    }
    case 7: {
      return "placeOfLoading";
      break;
    }
    case 8: {
      return "placeOfDelivery";
      break;
    }
    case 9: {
      return "placeOfDischarge";
      break;
    }
    case 10: {
      return "importer";
      break;
    }
    case 11: {
      return "consignee";
      break;
    }
    case 12: {
      return "harmonizedSystemCode";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.yy = (function() {
  return this.Bu;
});
$p.Wh = (function() {
  return this.Bt;
});
$p.bXN = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dPurchase$002dOrder$0024$0024anon$00241.$c_Lapp_data_AppDocumentDataPurchaseOrder$$anon$1().bwO(this);
});
$p.bXT = (function(now, createdAt) {
  var TransformerInto_this = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_dsl_TransformerInto(this, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_dsl_TransformerDefinition(($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$())));
  var TransformerInto_this$2 = TransformerInto_this.hw($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__empty__Lalleycats_Empty__Lalleycats_Empty($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lalleycats_EmptyInstances1__monoidIsEmpty__Lcats_kernel_Monoid__Lalleycats_Empty($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_kernel_instances_string_package$().aK)).aP());
  var this$10 = this.Bt;
  var TransformerInto_this$3 = TransformerInto_this$2.hw($j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo$002dForm$0024.$m_Lapp_data_AppDocumentOrganizationInfoForm$().np().ak(this$10));
  var TransformerInto_this$4 = TransformerInto_this$3.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$5 = TransformerInto_this$4.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$6 = TransformerInto_this$5.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$7 = TransformerInto_this$6.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$8 = TransformerInto_this$7.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$9 = TransformerInto_this$8.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$10 = TransformerInto_this$9.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$11 = TransformerInto_this$10.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$12 = TransformerInto_this$11.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$13 = TransformerInto_this$12.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$14 = TransformerInto_this$13.hw(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDateTime$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$(), now.dE)));
  var TransformerInto_this$15 = TransformerInto_this$14.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$16 = TransformerInto_this$15.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$17 = TransformerInto_this$16.hw(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(($j_app$002edata$002e$002dPurchase$002dOrder$002dContract$002dData$0024package$0024$002dPurchase$002dOrder$002dNumber$002dForm$0024.$m_Lapp_data_PurchaseOrderContractData$package$PurchaseOrderNumberForm$(), new $j_app$002edata$002e$002dPurchase$002dOrder$002dReference$002dForm.$c_Lapp_data_PurchaseOrderReferenceForm(this.Bu, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDateTime$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$(), createdAt.dE)))))));
  var TransformerInto_this$18 = TransformerInto_this$17.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$19 = TransformerInto_this$18.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$20 = TransformerInto_this$19.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$21 = TransformerInto_this$20.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$22 = TransformerInto_this$21.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$23 = TransformerInto_this$22.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var TransformerInto_this$24 = TransformerInto_this$23.hw($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var vector$macro$2 = TransformerInto_this$24.NZ.NX;
  var appdocumentdatapurchaseorder$macro$2 = TransformerInto_this$24.NY;
  var $x_30 = vector$macro$2.O(22);
  var $x_29 = vector$macro$2.O(21);
  var $x_28 = vector$macro$2.O(20);
  var $x_27 = vector$macro$2.O(19);
  var this$62 = appdocumentdatapurchaseorder$macro$2.Fc;
  if (this$62.c()) {
    var $x_22 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$62.g();
    var $x_26 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$();
    var $x_25 = $j_app$002edata$002e$002dDocumentary$002dCredit$002dData$0024package$0024$002dDocumentary$002dCredit$002dNumber$002dForm$0024.$m_Lapp_data_DocumentaryCreditData$package$DocumentaryCreditNumberForm$().aG().ak(arg1.uM);
    var $x_24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(arg1.uK).cs;
    var this$66 = arg1.uL;
    if (this$66.c()) {
      var $x_23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var arg1$1 = this$66.g();
      var $x_23 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dIssuing$002dBank$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBankForm$().aG().ak(arg1$1));
    }
    var $x_22 = $x_26.as(new $j_app$002edata$002e$002dDocumentary$002dCredit$002dForm$002dData.$c_Lapp_data_DocumentaryCreditFormData($x_25, $x_24, $x_23));
  }
  var this$68 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as(appdocumentdatapurchaseorder$macro$2.Fb);
  var $x_21 = (this$68.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as(this$68.g()));
  var $x_20 = vector$macro$2.O(18);
  var $x_19 = vector$macro$2.O(17);
  var this$72 = appdocumentdatapurchaseorder$macro$2.Fj;
  if (this$72.c()) {
    var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$3 = this$72.g();
    var $x_18 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dReceipt$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfReceiptForm$().aG().ak(arg1$3));
  }
  var this$74 = appdocumentdatapurchaseorder$macro$2.Fi;
  if (this$74.c()) {
    var $x_17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$4 = this$74.g();
    var $x_17 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dLoading$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfLoadingForm$().aG().ak(arg1$4));
  }
  var this$76 = appdocumentdatapurchaseorder$macro$2.Fg;
  if (this$76.c()) {
    var $x_16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$5 = this$76.g();
    var $x_16 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDelivery$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDeliveryForm$().aG().ak(arg1$5));
  }
  var this$78 = appdocumentdatapurchaseorder$macro$2.Fh;
  if (this$78.c()) {
    var $x_15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$6 = this$78.g();
    var $x_15 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dPlace$002dOf$002dDischarge$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$().aG().ak(arg1$6));
  }
  var $x_14 = vector$macro$2.O(16);
  var $x_13 = vector$macro$2.O(15);
  var ev$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_prelude_chimney$package$$anon$3($j_app$002edata$002e$002dInvoice$002dLine$002dItem$002dForm$0024.$m_Lapp_data_InvoiceLineItemForm$().bMo()).ak(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(appdocumentdatapurchaseorder$macro$2.Ff));
  var $x_12 = ((ev$16 === null) ? null : ev$16.b0);
  var $x_11 = vector$macro$2.O(14);
  var $x_10 = vector$macro$2.O(13);
  var $x_9 = vector$macro$2.O(12);
  var $x_8 = vector$macro$2.O(11);
  var this$81 = appdocumentdatapurchaseorder$macro$2.Fe;
  if (this$81.c()) {
    var $x_7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$7 = this$81.g();
    var $x_7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dImporter$002dName$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ImporterNameForm$().aG().ak(arg1$7));
  }
  var this$83 = appdocumentdatapurchaseorder$macro$2.Fa;
  if (this$83.c()) {
    var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$8 = this$83.g();
    var $x_6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dConsignee$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ConsigneeForm$().aG().ak(arg1$8));
  }
  var ev$17 = vector$macro$2.O(10);
  var $x_5 = ((ev$17 === null) ? null : ev$17.cs);
  var $x_4 = vector$macro$2.O(9);
  var $x_3 = vector$macro$2.O(8);
  var $x_2 = vector$macro$2.O(7);
  var this$85 = appdocumentdatapurchaseorder$macro$2.Fd;
  if (this$85.c()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1$9 = this$85.g();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dHarmonized$002dSystem$002dCode$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$HarmonizedSystemCodeForm$().aG().ak(arg1$9));
  }
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dInvoice$002dForm.$c_Lapp_data_AppDocumentDataInvoiceForm($x_30, $x_29, $x_28, $x_27, $x_22, $x_21, $x_20, $x_19, $x_18, $x_17, $x_16, $x_15, $x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, vector$macro$2.O(6), vector$macro$2.O(5), vector$macro$2.O(4), vector$macro$2.O(3), vector$macro$2.O(2), vector$macro$2.O(1), vector$macro$2.O(0));
});
function $isArrayOf_Lapp_data_AppDocumentDataPurchaseOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j0)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataPurchaseOrder as $isArrayOf_Lapp_data_AppDocumentDataPurchaseOrder };
var $d_Lapp_data_AppDocumentDataPurchaseOrder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataPurchaseOrder, "app.data.AppDocumentDataPurchaseOrder", ({
  j0: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataPurchaseOrder as $d_Lapp_data_AppDocumentDataPurchaseOrder };
//# sourceMappingURL=app.data.-App-Document-Data-Purchase-Order.js.map
